export default "__VITE_ASSET__22d0fac4__"